import computedStyle from '../utils/computedStyle';
export default function getNumericPropertyValue(node, prop) {
    return parseInt(computedStyle(node).getPropertyValue(prop), 10);
}
